import classNames from "classnames";

import DOD from "assets/img/common/dow-stem.png";
import styles from "./styles.module.scss";

export const CourseSupport = (props) => {
  const { paragraph, logo, logoClass } = props;
  return (
    <div
      className={classNames(styles.courseSupport, "bg-blue-gradient rounded")}
    >
      <div className="container">
        <div className={styles.content}>
          <span>
            {paragraph
              ? paragraph
              : "We are grateful for the support and partnership of"}
          </span>
          {logo ? (
            logo?.map((item, idx) => (
              <img src={item.src} className={logoClass} alt={item.alt} key={idx - item.src} />
            ))
          ) : (
            <img src={DOD} alt="DOD STEM" />
          )}
        </div>
      </div>
    </div>
  );
};
